import { render, staticRenderFns } from "./FooterDom.vue?vue&type=template&id=2276a7ea&scoped=true"
import script from "./FooterDom.vue?vue&type=script&lang=js"
export * from "./FooterDom.vue?vue&type=script&lang=js"
import style0 from "./FooterDom.vue?vue&type=style&index=0&id=2276a7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276a7ea",
  null
  
)

export default component.exports